import React from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';
import MyCard from './../MyCard.js';
import Card from 'react-bootstrap/Card';


class EX1secondaire extends React.Component{
  render(){
    return(
      <div>
          <Alert variant="danger">
            <h3>
              Exercices pour le premier année secondaire.
            </h3>
          </Alert>

          <Row>
              <MyCard
              title="Opération sur les nombres décimaux"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/nom_decimaux.pdf" />

              <MyCard
              title="Opération sur les nombres fractionnaires"
               ty="Exercice"
               color1="#7d9ccf"
               content=""
               fileUrl="/documents/file/pdf/1/exercice/nombre_fractionnaire.pdf" />

              <MyCard
              title="Droite dans le plan"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/droite_plan.pdf" />
          </Row>

          <Row>
              <MyCard
              title="Les nombres relatifs"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/nombre_relatifs.pdf" />

              <MyCard
              title="Angles et triangles"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/angles_triangle.pdf" />


              <MyCard
              title="Produit et quotient des nombres relatifs"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/n_relatids_produit_quotient.pdf" />
          </Row>



          <Row>
              <MyCard
              title="Somme et différence des nombres relatifs"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/n_relatids_somme_diffe.pdf" />

              <MyCard
              title="Le cercle"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/cercle.pdf" />


              <MyCard
              title="Les équations"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/equations.pdf" />
          </Row>



          <Row>
              <MyCard
              title="Factorisation et developement"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/fac_dev.pdf" />

              <MyCard
              title="Parallèlogrmme"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/parallelogramme_cas_particuliers.pdf" />


              <MyCard
              title="Repère dans le plan"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/repere.pdf" />
          </Row>



          <Row>
              <MyCard
              title="Statistique"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/statistique.pdf" />

              <MyCard
              title="Proportionalité"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/propo.pdf" />


              <MyCard
              title="Volumes"
              ty="Exercice"
              color1="#7d9ccf"
              content=""
              fileUrl="/documents/file/pdf/1/exercice/volumes.pdf" />
          </Row>


      </div>
    );
  }
}

export default EX1secondaire;
